<!-- menu -->
@switch (client.sizeId > 1) {
<!-- DESKTOP -->
@case (true) {
@for (item of navigation; track $index; let first = $first) {
<div [class.m-t-6]="!first">
    <a class="block"
       [routerLink]="item.link"
       [attr.cy-menuItem]="item.link">
        <icon-label [icon]="item.icon"
                    [offset]="4"
                    [textClass]="'s1'">{{item.label| translate}}</icon-label>
    </a>
</div>
}
<!-- logout -->
<div class="m-t-12 block">
    <icon-label [icon]="'logout'"
                [offset]="4"
                [textClass]="'s1'">
        <button inlineButton
                [buttonLine]="false"
                class="s1 inline-block"
                [status]="logoutStatus"
                (click)="logout()"
                cy-logoutbutton>{{'Sign out' | translate}}</button>
    </icon-label>
    <result [status]="logoutStatus"></result>
</div>
}
<!-- MOBILE -->
@case (false) {
<!-- dashboard countdown banner -->
<cms-countdown-banner [gridColumn]="1"
                      [variant]="'account-dashboard'"></cms-countdown-banner>
<div [grid]="2"
     [gridColumnGap]="'16px'"
     [gridRowGap]="'16px'">
    @for (item of navigation; track $index; let last = $last; let even = $even) {
    <a class="block bg-col-w p-l-3 p-r-3 p-t-5 p-b-5 center"
       [routerLink]="item.link"
       [attr.cy-menuItem]="item.link"
       [gridColumn]="last && even ? 2 : 1">
        <i [ngClass]="'icon-' + item.icon"
           [style.font-size.px]="25"></i>
        <p class="s1 m-t-2">{{item.label | translate}}</p>
    </a>
    }
</div>
<action class="button-1 m-t-10 w-12 "
        [status]="logoutStatus"
        cy-logoutbtn
        (click)="logout()">{{'Sign out' | translate}}
</action>
<result [status]="logoutStatus"></result>
}
}